var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLactoseFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 2C9.78207 2 7.455 2.95539 5.68848 4.52719L9.90949 8.7482C9.96152 8.54293 9.98891 8.3309 9.98891 8.11676V4.94922H14.6764V8.11676C14.6764 8.71773 14.8883 9.30297 15.273 9.76465C15.8329 10.4365 16.1413 11.2882 16.1413 12.1628V14.98L19.8055 18.6442C21.3773 16.8777 22.3327 14.5506 22.3327 12C22.3327 6.47715 17.8555 2 12.3327 2V2Z",
    fill: "#036EB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9695 12.5541V12.1627C14.9695 11.5618 14.7576 10.9765 14.3729 10.5148C13.8877 9.93254 13.5918 9.21512 13.5214 8.46484H11.1442C11.0738 9.21512 10.778 9.93254 10.2927 10.5148C10.0289 10.8313 9.84652 11.2059 9.75781 11.6037C11.0415 11.6607 11.7829 11.8852 12.5027 12.1033C13.1806 12.3087 13.8265 12.5042 14.9695 12.5541Z",
    fill: "#036EB8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9697 13.7264C13.6477 13.674 12.8944 13.4459 12.1631 13.2242C11.4852 13.0188 10.8393 12.8233 9.69629 12.7734V17.2533H14.9697V13.7264Z",
    fill: "#036EB8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1611 6.12109H13.5049V7.29297H11.1611V6.12109Z",
    fill: "#036EB8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 21.9996C14.8836 21.9996 17.2107 21.0443 18.9772 19.4725L16.1416 16.6369V18.4254H8.52441V12.1624C8.52441 11.3172 8.81312 10.4939 9.33781 9.83309L4.86019 5.35547C3.2884 7.12199 2.33301 9.44906 2.33301 11.9996C2.33301 17.5225 6.81016 21.9996 12.333 21.9996Z",
    fill: "#036EB8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLactoseFree);
export default __webpack_public_path__ + "static/media/lactose-free.99f59c37.svg";
export { ForwardRef as ReactComponent };